import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import logo from '../../assets/Okiri-logo-rmbg.png';
import logoScrolled from '../../assets/okiri-logo-bw-rmbg.png'; // Your alternate logo on scroll

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navRef = useRef(null);
  const hamburgerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 0);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu if click outside nav or hamburger button
  useEffect(() => {
    if (!isMenuOpen) return;

    function handleClickOutside(event) {
      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  // Disable body scroll and close menu if user scrolls/touches outside sidebar
  useEffect(() => {
    if (isMenuOpen) {
      // Disable body scroll
      document.body.style.overflow = 'hidden';

      function handleScrollOrTouch(e) {
        if (navRef.current && navRef.current.contains(e.target)) {
          // Scroll/touch inside sidebar — allow scrolling, do nothing
          return;
        }
        // Scroll/touch outside sidebar — close menu
        setIsMenuOpen(false);
      }

      window.addEventListener('wheel', handleScrollOrTouch, { passive: true });
      window.addEventListener('touchmove', handleScrollOrTouch, { passive: true });

      return () => {
        document.body.style.overflow = ''; // re-enable scroll
        window.removeEventListener('wheel', handleScrollOrTouch);
        window.removeEventListener('touchmove', handleScrollOrTouch);
      };
    } else {
      document.body.style.overflow = ''; // Ensure scroll enabled if menu closed
    }
  }, [isMenuOpen]);

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="header__logo">
        <img src={isScrolled ? logoScrolled : logo} alt="Logo" />
      </div>
      <nav ref={navRef} className={`header__nav ${isMenuOpen ? 'open' : ''}`}>
        <div className="nav-links">
          <a href="#features" onClick={() => setIsMenuOpen(false)}>Features</a>
          <a href="#pricing" onClick={() => setIsMenuOpen(false)}>Plans</a>
          <a href="#footer" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
        </div>
        <button className="download-button" onClick={() => setIsMenuOpen(false)}>
          Download
        </button>
      </nav>
      <button
        ref={hamburgerRef}
        className={`hamburger ${isMenuOpen ? 'open' : ''}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>
    </header>
  );
}

export default Header;
